import { Alert, Flex, Text } from "@mantine/core";

export function TransformerBase({
  children,
  error,
  warning,
}: {
  children?: React.ReactNode;
  error?: string;
  warning?: string;
}) {
  return (
    <Flex direction="column" gap={8} px="xs">
      {children}
      {warning && (
        <Alert w="100%" color="yellow" p={8}>
          <Text c="yellow" fz={14} lh={1.4} fw={500}>
            {warning}
          </Text>
        </Alert>
      )}
      {error && (
        <Alert w="100%" color="red" p={8}>
          <Text c="red" fz={14} lh={1.4} fw={500}>
            {error}
          </Text>
        </Alert>
      )}
    </Flex>
  );
}
